import { FC } from 'react';
import { Switch } from '@mui/material';
import { IBaseFieldProps } from './types';

export const FieldBoolean: FC<IBaseFieldProps<unknown>> = ({ formField, formProps }) => {
  const { value, onChange } = formProps;
  const { disabled = false } = formField ?? {};

  return (
    <Switch
      checked={value ?? false}
      onChange={(e, checked) => onChange(checked)}
      disabled={disabled}
      size='small'
    />
  );
};
